import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=6fbc2773&"
import script from "./BillingSummary.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillingSummary.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports